"use strict";

// Load Trustpilot widgets when relevant DOM elements become present
(function(){
  const params = new URLSearchParams(window.location.search);
  if (params.get('view') != 'compare') return;

  // Check every 250ms if Trustpilot is loaded
  const trustpilotLoadInterval = setInterval(() => {
    // Let the interval run until Trustpilot is loaded
    if (!window.Trustpilot) return;
    clearInterval(trustpilotLoadInterval);

    // Start monitoring every 1.5s for new widgets in the comparison table
    const compareTableInterval = setInterval(() => {
      var element = document.querySelectorAll('.product-compare-container .trustpilot-widget');
      for(var i=0; i<element.length; i++) {
        window.Trustpilot.loadFromElement(element[i]);
      }
    }, 1500);

    // Stop monitoring for new widgets after 5s
    setTimeout(() => clearInterval(compareTableInterval), 5000);

    // Start monitoring every 1.5s for new widgets in the recently viewed block
    const recentlyViewedInterval = setInterval(() => {
      var element = document.querySelectorAll('.product-recently-viewed__wrapper .trustpilot-widget');
      for(var i=0; i<element.length; i++) {
        window.Trustpilot.loadFromElement(element[i]);
      }
    }, 1500);

    // Stop monitoring for new widgets after 5s
    setTimeout(() => clearInterval(recentlyViewedInterval), 5000);
  }, 250);

  // Abort if Trustpilot still hasn't loaded after 5s
  setTimeout(() => clearInterval(trustpilotLoadInterval), 5000);
})();


// Set Backorder properties on cart items
document.addEventListener('DOMContentLoaded', function() {
  const BACKORDER_KEY = "Backorder";
  const BACKORDER_VALUE = "Item will be fulfilled when back in stock.";

  function changeLineItem(key, properties) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, properties: properties }),
    }).then((res) => res.json());
  }

  function getCart() {
    return fetch("/cart.js").then((res) => res.json());
  }

  const keysToSet = [];
  const keysToRemove = [];
  document.querySelectorAll('.cart-item[data-cartitem-backorder-action="set"]').forEach((el) => {
    const key = el.getAttribute("data-cartitem-key");
    if (key) keysToSet.push(key);
  });
  document.querySelectorAll('.cart-item[data-cartitem-backorder-action="remove"]').forEach((el) => {
    const key = el.getAttribute("data-cartitem-key");
    if (key) keysToRemove.push(key);
  });

  if (keysToSet.length === 0 && keysToRemove.length === 0) return;

  getCart()
    .then((cart) => {
      const itemsByKey = {};
      (cart.items || []).forEach((item) => {
        itemsByKey[item.key] = item;
      });

      keysToSet.forEach((key) => {
        const item = itemsByKey[key];
        const properties = (item && item.properties) ? { ...item.properties } : {};
        properties[BACKORDER_KEY] = BACKORDER_VALUE;
        changeLineItem(key, properties).catch(console.error);
      });

      keysToRemove.forEach((key) => {
        const item = itemsByKey[key];
        const properties = (item && item.properties) ? { ...item.properties } : {};
        delete properties[BACKORDER_KEY];
        changeLineItem(key, properties).catch(console.error);
      });
    })
    .catch(console.error);
});
